import React from 'react'
import Referrals from './Referrals'
import gql from 'graphql-tag'
import DataContainer from 'components/DataContainer/DataContainer'
import Loadable from 'components/Loadable/Loadable'
import MediaQuery from 'components/MediaQuery/MediaQuery'

const queries = [
  {
    query: gql`
      {
        me {
          _id
          parent
          type
          ambassador
          school {
            _id
            teachers {
              _id
            }
          }
          subscription {
            id
            plan {
              
              interval
            }
            start
            discount {
              coupon {
                id
                percent_off
              }
            }
          }
          referrer {
            _id
          }
          referral {
            _id
            users {
              _id
            }
          }
          isSubscribe
        }
      }
    `,
    props: ({ data }) => {
      if (data.loading || data.error) {
        return { loading: data.loading, error: data.error }
      }
      const currentSubscription = data.me.subscription || false
      return {
        loading: data.loading,
        error: data.error,
        parent: data.me.parent,
        subscriptionType: currentSubscription.plan && currentSubscription.plan.interval || '',
        startDate: currentSubscription.start || 0,
        referralId: data.me.referral._id,
        teachers: data.me.school ? data.me.school.teachers : [],
        ambassador: data.me.ambassador || false,
        discountPercentage: currentSubscription.discount ? currentSubscription.discount.coupon ? currentSubscription.discount.coupon.percent_off : null : null,
        isSubscribed: data.me.isSubscribe
      }
    },
    options: {
      fetchPolicy: 'network-only'
    }
  }
]

const mutations = [
  {
    mutation: gql`
      mutation referMutation($emails: [String]!) {
        refer(emails: $emails)
      }
    `,
    props: ({ mutate }) => ({
      sendReferral: (emails) =>
        mutate({
          variables: {
            emails
          }
        })
    })
  },
  {
    mutation: gql`
      mutation ambassadorMutation {
        ambassador
      }
    `,
    props: ({ mutate }) => ({
      ambassadorSignUp: mutate
    })
  }
]

const freeEmail = async (client, email) => {
  const { data } = await client.query({
    query: gql`
      query freeEmail($email: String!) {
        freeEmail(email: $email)
      }
    `,
    variables: { email },
    fetchPolicy: 'network-only'
  })
  return data.freeEmail
}

const ReferralsContainer = props => <MediaQuery><Referrals {...props} freeEmail={freeEmail} /></MediaQuery>

export default props => (
  <DataContainer queries={queries} mutations={mutations}>
    <ReferralsContainer {...props} />
  </DataContainer>
)
